import React from 'react';
import { themed } from '../../ui/theme';

export type BadgeTone = 'neutral' | 'success' | 'danger' | 'warning' | 'info';
export type BadgeSize = 'sm' | 'md';

// minimal: contorno + texto (flat), mas com contraste suficiente para se destacar.
const MINIMAL: Record<BadgeTone, string> = {
  neutral: 'border-slate-400 text-slate-700 dark:border-slate-500 dark:text-slate-200',
  success: 'border-emerald-500 text-emerald-700 dark:border-emerald-500 dark:text-emerald-300',
  danger: 'border-red-500 text-red-700 dark:border-red-500 dark:text-red-300',
  warning: 'border-amber-500 text-amber-700 dark:border-amber-500 dark:text-amber-300',
  info: 'border-sky-500 text-sky-700 dark:border-sky-500 dark:text-sky-300',
};

// saas: preenchido (borda + fundo + texto).
const SAAS: Record<BadgeTone, string> = {
  neutral: 'border-slate-300 bg-slate-100 text-slate-700 dark:border-slate-600 dark:bg-slate-700/60 dark:text-slate-200',
  success: 'border-emerald-300 bg-emerald-50 text-emerald-700 dark:border-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-300',
  danger: 'border-red-300 bg-red-50 text-red-700 dark:border-red-700 dark:bg-red-900/30 dark:text-red-300',
  warning: 'border-amber-300 bg-amber-50 text-amber-700 dark:border-amber-700 dark:bg-amber-900/30 dark:text-amber-300',
  info: 'border-sky-300 bg-sky-50 text-sky-700 dark:border-sky-700 dark:bg-sky-900/30 dark:text-sky-300',
};

const SIZES: Record<BadgeSize, string> = {
  sm: 'px-2 py-0.5 text-[0.7rem]',
  md: 'px-2.5 py-1 text-xs',
};

interface Props {
  children: React.ReactNode;
  tone?: BadgeTone;
  size?: BadgeSize;
  className?: string;
}

const StatusBadge: React.FC<Props> = ({ children, tone = 'neutral', size = 'sm', className = '' }) => (
  <span className={`inline-flex items-center rounded-md border font-semibold ${SIZES[size]} ${themed({ minimal: MINIMAL, saas: SAAS })[tone]} ${className}`}>
    {children}
  </span>
);

export default StatusBadge;
